import { useState, useEffect, useRef } from 'react';

export default function useVersionCheck() {
    const [updateAvailable, setUpdateAvailable] = useState(false);
    const currentVersion = useRef(null);

    useEffect(() => {
        const check = async () => {
            try {
                const res = await fetch('/version.json?t=' + Date.now());
                const data = await res.json();

                if (currentVersion.current === null) {
                    currentVersion.current = data.version;
                } else if (data.version !== currentVersion.current) {
                    setUpdateAvailable(true);
                }
            } catch (e) {}
        };

        check();
        const interval = setInterval(check, 5 * 60 * 1000); // toutes les 5 min
        return () => clearInterval(interval);
    }, []);

    return updateAvailable;
}